import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock, Unlock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatDateTime } from "@/lib/dateFormat";
import { useI18n } from "@/context/I18nContext";

export const LockedAccountsPanel = () => {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  const load = async () => {
    const r = await api.get("/admin/locked-accounts");
    setItems(r.data);
  };

  useEffect(() => {
    load().catch(() => {});
  }, []);

  const unlock = async (u) => {
    try {
      await api.post(`/admin/users/${u.id}/unlock`);
      toast.success(t("account_unlocked"));
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <Card data-testid="locked-accounts-panel">
      <CardContent className="space-y-3 p-5">
        <div className="flex items-center gap-2">
          <Lock className="h-4 w-4 text-primary" />
          <h3 className="font-semibold">{t("locked_accounts")}</h3>
        </div>
        <p className="text-sm text-muted-foreground">{t("locked_accounts_desc")}</p>
        {items.length === 0 ? (
          <p className="text-sm text-muted-foreground" data-testid="locked-accounts-empty">{t("locked_accounts_empty")}</p>
        ) : (
          <ul className="divide-y divide-border">
            {items.map((u) => (
              <li key={u.id} className="flex flex-wrap items-center justify-between gap-3 py-2" data-testid={`locked-account-${u.id}`}>
                <div className="min-w-0">
                  <div className="truncate font-medium">{u.name || u.email}</div>
                  <div className="truncate text-xs text-muted-foreground">
                    {u.email} · {t("locked_until")} {formatDateTime(u.locked_until)}
                  </div>
                </div>
                <Button size="sm" variant="outline" onClick={() => unlock(u)} data-testid={`unlock-account-btn-${u.id}`}>
                  <Unlock className="mr-1 h-3.5 w-3.5" /> {t("unlock_account")}
                </Button>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};
